import { render, staticRenderFns } from "./owners.vue?vue&type=template&id=19265f1e&"
import script from "./owners.vue?vue&type=script&lang=js&"
export * from "./owners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports